<div
  [ngStyle]="{'background-color': 'white','color': 'black', 'min-height': '30px', 'margin' : '2px', 'border': '1px solid black' }">

  <div style="overflow: hidden; white-space: nowrap;">
    <img [src]='this.getSafeUrl(item.triggerIcon)' style='width:20px; height:20px; vertical-align:middle;'
      [class.grayscale]="item.flowState!='Started'" />
      @if (item.flowState=='Deleted') {
        <span class='k-icon k-i-close-circle cell cell-filter' style='color:red'
        title='Deleted'></span>
      }
      <span style="width:130px; text-overflow: ellipsis; overflow:hidden; white-space: nowrap; display:inline-block;"
      [class.stopped]="item.flowState=='Stopped'" title="{{item.displayName}}">{{item.displayName}}</span>

      <div style="width:100px; height: 20px; display: inline-block;">

        <kendo-sparkline type="column" renderAs="canvas" (click)="doGetRuns(item)">
          <kendo-chart-area background="transparent" [margin]="1"> </kendo-chart-area>

          <kendo-chart-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value">
              <!-- start: {{ value | json }} <br> -->
            duration: {{ value }}ms </ng-template>

          </kendo-chart-tooltip>

          <kendo-chart-series>
            <kendo-chart-series-item type="column" [data]="runsSparkline" [gap]="1"> </kendo-chart-series-item>

          </kendo-chart-series>

        </kendo-sparkline>

      </div>

    </div>

  </div>